import { ChakraProvider, theme } from '@chakra-ui/react'
import { Routes, Route } from 'react-router-dom'

import { Dashboard, Application } from './pages'

export const App = () => (
  <ChakraProvider theme={theme}>
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/app" element={<Application />}>
        <Route path=":name" element={<Application />} />
        <Route path=":name/:tab" element={<Application />} />
      </Route>
      <Route path="/app/new" element={<Dashboard />} />
      <Route path="*" element={<Dashboard />} />
    </Routes>
  </ChakraProvider>
)
